import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, ExternalLink } from 'lucide-react';
import { COMPANY_INFO } from '../../data/mock';

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  const navLinks = [
    ['/', 'Home'],
    ['/services', 'Services'],
    ['/commercial', 'Commercial'],
    ['/contact', 'Contact'],
  ];

  return (
    <>
      {/* ── Logo banner ── */}
      <div className="bg-white w-full">
        <img
          src="/header_new.png"
          alt="AAA Irrigation Service — Integrity By The Drop Since 2005"
          className="w-full block"
          style={{ height: 'auto', display: 'block' }}
          width="1920"
          height="300"
        />
      </div>

      {/* ── Navigation bar ── */}
      <nav className="sticky top-0 z-50 bg-[#1b7abf] shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-12">

            {/* Desktop nav links */}
            <div className="hidden md:flex items-center gap-1">
              {navLinks.map(([path, label]) => (
                <Link
                  key={path}
                  to={path}
                  className={`px-4 py-2 text-sm font-bold uppercase tracking-wide transition-all duration-200 rounded ${
                    isActive(path)
                      ? 'bg-white/20 text-white'
                      : 'text-blue-100 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {label}
                </Link>
              ))}
              <a
                href="https://portal.aaairrigationservice.com"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 text-sm font-bold text-blue-100 hover:text-white hover:bg-white/10 transition-all duration-200 rounded flex items-center gap-1 uppercase tracking-wide"
              >
                Portal <ExternalLink className="w-3 h-3" />
              </a>
            </div>

            {/* Desktop phone + CTA */}
            <div className="hidden md:flex items-center gap-4">
              <a
                href={`tel:${COMPANY_INFO.phone}`}
                className="flex items-center gap-2 text-white hover:text-blue-100 transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="font-black text-lg tracking-wide">{COMPANY_INFO.phoneFormatted}</span>
              </a>
              <Link
                to="/schedule"
                className="bg-[#ea580c] hover:bg-[#c2410c] text-white font-black px-5 py-2 rounded-lg shadow-md transition-all duration-200 text-sm uppercase tracking-wide"
              >
                Schedule Service
              </Link>
            </div>

            {/* Mobile: phone + hamburger */}
            <div className="md:hidden flex items-center gap-3 w-full justify-between">
              <a
                href={`tel:${COMPANY_INFO.phone}`}
                className="flex items-center gap-2 text-white font-bold text-sm"
              >
                <Phone className="w-4 h-4" />
                {COMPANY_INFO.phoneFormatted}
              </a>
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="p-1.5 text-white hover:bg-white/10 rounded transition-colors"
                aria-label="Toggle menu"
              >
                {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="md:hidden bg-[#155f96] border-t border-blue-700 px-4 py-3 space-y-1">
            {navLinks.map(([path, label]) => (
              <Link
                key={path}
                to={path}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 rounded-lg font-bold text-sm uppercase tracking-wide transition-colors ${
                  isActive(path)
                    ? 'bg-white/20 text-white'
                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                }`}
              >
                {label}
              </Link>
            ))}
            <a
              href="https://portal.aaairrigationservice.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 rounded-lg text-blue-100 font-bold text-sm hover:bg-white/10 hover:text-white uppercase tracking-wide"
            >
              Customer Portal ↗
            </a>
            <Link
              to="/schedule"
              onClick={() => setMobileOpen(false)}
              className="block bg-[#ea580c] hover:bg-[#c2410c] text-white font-bold px-4 py-3 rounded-xl text-center uppercase tracking-wide text-sm mt-2"
            >
              Schedule Service
            </Link>
          </div>
        )}
      </nav>
    </>
  );
};
